import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12 1.21H4A2.75 2.75 0 0 0 1.26 4v5A2.75 2.75 0 0 0 4 11.7h2v.75c0 .75-.31.75-.49.75a.75.75 0 1 0 0 1.5h4.9a.75.75 0 0 0 0-1.5c-.19 0-.5 0-.5-.75v-.75h2A2.75 2.75 0 0 0 14.76 9V4A2.75 2.75 0 0 0 12 1.21Zm-3.46 12H7.46a3 3 0 0 0 .09-.75v-.76h.91v.75a3 3 0 0 0 .09.75ZM13.26 9A1.26 1.26 0 0 1 12 10.2H4A1.25 1.25 0 0 1 2.76 9V4A1.25 1.25 0 0 1 4 2.71h8A1.26 1.26 0 0 1 13.26 4Z';
const draw24px =
  'M20,2.22H4A2.75,2.75,0,0,0,1.25,5V15A2.75,2.75,0,0,0,4,17.76H9.24v1.73c0,1.76-1,1.76-1.32,1.76H7.38a.75.75,0,1,0,0,1.5h9.25a.75.75,0,0,0,0-1.5h-.54c-.33,0-1.32,0-1.32-1.76V17.76H20A2.75,2.75,0,0,0,22.75,15V5A2.75,2.75,0,0,0,20,2.22Zm-6.37,19H10.39a4.09,4.09,0,0,0,.35-1.76V17.76h2.53v1.73A4,4,0,0,0,13.63,21.25ZM21.25,15A1.25,1.25,0,0,1,20,16.26H4A1.25,1.25,0,0,1,2.75,15V5A1.25,1.25,0,0,1,4,3.72H20A1.25,1.25,0,0,1,21.25,5ZM10.14,16.26h0Zm4,0h0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const DesktopIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'desktop'),
) as IconWithRender;

DesktopIcon.displayName = 'DesktopIcon';
DesktopIcon.propTypes = Icon.propTypes;
DesktopIcon.renderIcon = (props) => <DesktopIcon {...props} />;
export default DesktopIcon;
